



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { hexToRgb, hexToRgbValues, isValidHexColor } from '@/core/color/color.service';
import tailwind from '@/styling/tailwind.config';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import breakpointState from '@/core/responsive/breakpoints/breakpointsState.observable';
import { MAX_MD } from '@/core/config/breakpointConfig';
import { AdImage, Link } from '@/types/apiServerContract';
import CallToAction from '@/project/form/CallToAction.vue';
// Use custom interface because this banner only have some of the options we have in a normal banner.
interface SmallImageTextBlockViewModel {
    lineItemId?: string;
    creativeId?: string;
    backgroundColor?: string;
    headerColor?: string;
    header?: string;
    subheader?: string;
    callToAction?: Link;

    callToActionColor?: string;
    subheaderColor?: string;
    contentBackgroundColor?: string;
    makeContentBackgroundTransparent?: boolean;
    backgroundImages?: AdImage[];
    shim: boolean | undefined;
    shimColor?: string;
}
interface extendedCSSStyleDeclarationWithContentBackgroundColor extends CSSStyleDeclaration {
    contentBackgroundColor?: string;
    aspectRatio?: number;
}
@Component({
    components: { SmartHeadline }
})
export default class SmallImageTextBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: SmallImageTextBlockViewModel;

    @Prop({
        type: Boolean,
        default: false,
        required: false
    }) setStyleAspectRatioOnDesktop!: boolean;

    @Prop({
        type: Function,
        default: () => {}
    }) clickHandler!: () => void;

    rendered = false;

    get isMobile() {
        return breakpointState.isBreakpointActive(MAX_MD);
    }

    get style(): Partial<extendedCSSStyleDeclarationWithContentBackgroundColor> {
        if (!this.content) return {};
        const styling: Partial<extendedCSSStyleDeclarationWithContentBackgroundColor> = {};
        let backgroundImage: null | AdImage = null;
        if (this.content.backgroundImages?.length) {
            if (this.content.backgroundImages.length > 1 && this.isMobile) {
                backgroundImage = this.content.backgroundImages[1];
            } else {
                backgroundImage = this.content.backgroundImages[0];
            }
        }
        if (backgroundImage) {
            if (this.isMobile || this.setStyleAspectRatioOnDesktop) {
                // styling.aspectRatio = backgroundImage ? backgroundImage.width / backgroundImage.height : 360 / 190;
                const height = (backgroundImage ? backgroundImage.height : 190);
                const width = (backgroundImage ? backgroundImage.width : 360);
                const element = this.$refs.element;
                const elementWidth = element?.getBoundingClientRect()?.width || width;
                const heightRatio = (height / width) * elementWidth;
                styling.minHeight = heightRatio + 'px';
            } else {
            }
            styling.backgroundSize = 'cover';
            styling.backgroundImage = `url(${backgroundImage.url})`;
            styling.backgroundPosition = '50% 50%';
        }
        styling.flex = '1';
        styling.backgroundRepeat = 'no-repeat';

        const backgroundColor = this.content.contentBackgroundColor;
        const semiTransparent = this.content.makeContentBackgroundTransparent;

        let result = 'transparent';
        const semiTransparencyPercentage = 0.75;

        if (this.content.backgroundImages?.length && backgroundColor && this.isColorDefined(backgroundColor)) {
            result = this.hexToRgbWithDefault(backgroundColor, semiTransparent ? semiTransparencyPercentage : undefined);
        }

        styling.backgroundColor = result;
        styling.contentBackgroundColor = result;
        return styling;
    }

    hexToRgbWithDefault(hex: string, alpha?: number): string {
        if (!isValidHexColor(hex)) return tailwind.theme.colors.black;
        return hexToRgb(hex, alpha);
    }

    colorStyle(hexColor?: string): object {
        const defailtColor = tailwind.theme.colors.white;
        return ({
            color: this.style?.contentBackgroundColor === 'white' ? defailtColor : hexColor ? this.hexToRgbWithDefault(hexColor) : defailtColor
        });
    }

    isColorDefined(color: string): boolean {
        return color?.length === 7 ?? false; // #233445
    }

    $refs!: {
        element?: HTMLElement,
        callToAction?: CallToAction
    }

    mounted() {
        this.$nextTick(() => {
            this.rendered = true;
            this.$nextTick(() => {
                if (this.$refs.callToAction?.$el && this.content.shimColor && this.isColorDefined(this.content.shimColor)) {
                    const element = this.$refs.callToAction.$el as HTMLElement;
                    const { red, green, blue } = hexToRgbValues(this.content.shimColor);
                    const hoverL = 0.6;
                    element.style.setProperty('--hover-active-color', `rgba(${red},${green},${blue},${hoverL})`);
                }
            });
        });
    }
}
